import { render, staticRenderFns } from "./PmtaConfig.vue?vue&type=template&id=04741a0d&scoped=true"
import script from "./PmtaConfig.vue?vue&type=script&lang=js"
export * from "./PmtaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04741a0d",
  null
  
)

export default component.exports